import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Wrap = styled(Link)`
  font-family: var(--regular);
  color: var(--orange);
  text-decoration: underline;
  font-size: 0.875em;
`
